import styled from 'styled-components'
import { TestType } from '../../const/type'
import theme from '../../const/theme'
import { Small } from '../../typography'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

export const TestCardWrapper = styled.div`
  width: 280px;
  height: 120px;
  border: 1px solid ${({ theme }) => theme.card.border};
  border-radius: 10px;
  box-shadow: 0 1px 10px 0 ${({ theme }) => theme.card.border};
  margin: 0 4px 8px;
  @media (max-width: 415px) {
    width:100%;
  }
};
`

interface TestCardHeaderProps {
  testType?: string
}

const scheduledTestStyle = `
background-image: linear-gradient(
  180deg,
  ${theme.performanceCard.scheduledTest.background},
  ${theme.performanceCard.scheduledTest.gradient} 99.94%
);
`

const attemptedTestStyle = `
background-image: linear-gradient(
  180deg,
  ${theme.performanceCard.attemptedTest.background},
  ${theme.performanceCard.attemptedTest.gradient} 99.94%
);
`

export const TestCardHeader = styled.div<TestCardHeaderProps>`
  width: 100%;
  height: 50%;
  padding: 4px 8px;
  ${({ testType }) => {
    switch (testType) {
      case TestType.SCHEDULED:
        return scheduledTestStyle
      case TestType.ATTEMPTED:
        return attemptedTestStyle
      default:
        return scheduledTestStyle
    }
  }}
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
`

export const TestCardDetails = styled.div`
  width: 100%;
  height: 50%;
  padding: 12px 8px;
`

export const TestDetails = styled(Small)`
  margin: auto 4px;
`

export const TimeIcon = styled(FontAwesomeIcon)`
  margin: auto 4px;
`
